<template>
	<div class="max-width">
		<div class="subs">
			<router-link to="/" class="subs__links">Home</router-link>
			<router-link to="/help-center/" class="subs__links"
				>Help Center</router-link
			>
			<span>Megastore</span>
		</div>

		<div class="sh-documentation-theme">
			<aside class="sh-documentation-theme__sidebar">
				<div class="sh-documentation-theme__sidebar-inner">
					<div class="sh-documentation-theme__sidebar-nav">
						<div class="sh-documentation-theme__sidebar-wrapper">
							<ul class="sh-documentation-theme__sidebar-list">
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#theme-settings">Theme Settings</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#color-swatches">Color Swatches</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#color-swatches-multilanguage"
														>Multilanguage Color Swatches</a
													>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-card">Product Card</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#custom-badges">Custom Product Badges</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#pagination">Pagination</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#back-to-top">Back to Top</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#header-group">Header Group</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#announcement-bar">Announcement Bar</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#header">Header</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#header-mega-menu">Mega Menu Blocks</a>
													<ul class="sh-documentation-theme__sidebar-sublist">
														<li
															class="sh-documentation-theme__sidebar-sublist-item"
														>
															<a href="#header-mega-menu-cards"
																>Mega Menu with Cards</a
															>
														</li>
														<li
															class="sh-documentation-theme__sidebar-sublist-item"
														>
															<a href="#header-mega-menu-tabs"
																>Mega Menu with Tabs</a
															>
														</li>
														<li
															class="sh-documentation-theme__sidebar-sublist-item"
														>
															<a href="#header-mega-menu-multilanguage"
																>Multilanguage Mega Menu Trigger</a
															>
														</li>
													</ul>
												</li>
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#header-search">Search Modal</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#shop-mega-menu">Shop Mega Menu Section</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#overlay-group">Overlay Group</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#popup">Popup</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#notification-banner">Notification Banner</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#notification-bar">Notification Bar</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#age-verifier">Age Verification Popup</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#footer-group">Footer Group</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#footer">Footer</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#all-sections">Sections</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#sections-general-settings">General Settings</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#section-margin">Section Margin</a>
												</li>
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#section-padding">Section Padding</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#featured-collection">Featured Collection</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#featured-product">Featured Product</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#rte">Rich Text</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#image-with-text">Image with Text</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#slideshow">Slideshow</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#multicolumn">Multicolumn</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collapsible-content">Collapsible Content</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#banner-grid">Banner Grid</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#banner-slider">Banner Slider</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#before-after">Before / After</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#blog-posts">Blog Posts</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#brands">Brands</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collections-list">Collections List</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#countdown">Countdown</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-carousel">Popular Products</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-markers">Product Markers</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-tabs">Products Ttabs</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#testimonials">Testimonials</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#ticker">Ticker</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#page">Pages</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#product-page">Product Page</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#product-information">Product Information</a>
												</li>

												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#product-recommendations"
														>Product Recommendations</a
													>
												</li>

												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#variant-picker">Variant Picker</a>

													<ul class="sh-documentation-theme__sidebar-sublist">
														<li
															class="sh-documentation-theme__sidebar-sublist-item"
														>
															<a href="#variant-picker-pills">Pills</a>
														</li>

														<li
															class="sh-documentation-theme__sidebar-sublist-item"
														>
															<a href="#variant-picker-dropdown">Dropdown</a>
														</li>
													</ul>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collections-page">Collections Page</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#collection-banner">Collection Banner</a>
												</li>
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#product-grid">Product Grid</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#collections-list-page">Collections List</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#cart">Cart</a>
											<ul class="sh-documentation-theme__sidebar-sublist">
												<li
													class="sh-documentation-theme__sidebar-sublist-item"
												>
													<a href="#cart-shipping">Free shipping message</a>
												</li>
											</ul>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#blog">Blog</a>
										</li>
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#blog-post">Blog Post</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#import-demos">Importing Our Demos</a>
									<ul class="sh-documentation-theme__sidebar-sublist">
										<li class="sh-documentation-theme__sidebar-sublist-item">
											<a href="#demos-structure">Demos Structure</a>
										</li>
									</ul>
								</li>
								<li class="sh-documentation-theme__sidebar-list-item">
									<a href="#support">Support</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</aside>
			<div class="sh-documentation-theme__content">
				<div class="sh-content">
					<h1 id="started">Megastore</h1>
					<p>
						Below you’ll find a list of articles broken down by sub topics that
						cover each and every aspect of your theme. We regularly maintain our
						documentation in collaboration with our support staff.
					</p>

					<!------------------------------ THEME SETTINGS (START) ------------------------------>

					<h2 id="theme-settings">Theme Settings</h2>

					<p>With the Theme settings, you can:</p>
					<ul>
						<li>Manage color schemes</li>
						<li>Customize the appearance of text elements</li>
						<li>Upload a favicon</li>
						<li>Control the appearance of product cards</li>
						<li>
							Manage the Quick View and Quick Add buttons inside product cards
						</li>
						<li>Enable and customize color swatches</li>
						<li>
							Manage Predictive Search (please note: Predictive Search is not
							supported in Shopify for some languages)
						</li>
						<li>Enable and customize the Cart Drawer for faster purchases</li>
						<li>
							Customize pagination (limited to pages specified in the notes)
						</li>
						<li>Add links to your social media</li>
						<li>
							Apply custom CSS styles if you need to override the theme's
							default styles
						</li>
					</ul>
					<figure>
						<img src="/assets/imgs/docs/megastore/theme_settings_1.webp" />
					</figure>

					<h3 id="color-swatches">Color Swatches</h3>
					<p>
						To enable and edit Color swatches, navigate to Theme settings >
						Color swatch.
					</p>
					<p>
						If product color options are added via
						<a
							href="https://help.shopify.com/en/manual/custom-data/metafields/category-metafields/using-category-metafields"
							aria-label="Category metafields in Shopify Help Center"
							target="_blank"
							><b>category metafields</b></a
						>, they will <b>automatically</b> appear in the following locations:
					</p>
					<ul>
						<li>On the product page</li>
						<li>In the featured product section</li>
						<li>
							On the collection page in filters. Customize filters with the
							<a
								href="https://help.shopify.com/en/manual/online-store/search-and-discovery/filters"
								aria-label="Category metafields in Shopify Help Center"
								target="_blank"
								>Search and Discovery app</a
							>.
						</li>
					</ul>
					<p>
						If the product color option is added as a <b>custom option</b>, the
						Swatch trigger field must be filled in to display color swatches.
						You can also add custom colors by adding their name and color in HEX
						format.
					</p>
					<p>
						To display color swatches on the <b>product card</b>, the Swatch
						trigger field must also be filled in.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/color_swatches_1.webp" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/megastore/color_swatches_2.webp" />
					</figure>

					<h3 id="color-swatches-multilanguage">
						Multilanguage Color Swatches
					</h3>
					<p>
						In this section, we will show how to create multilingual color
						swatches using the
						<a
							href="https://apps.shopify.com/translate-and-adapt"
							aria-label="Shopify Translate & Adapt app"
							target="_blank"
							>Shopify Translate & Adapt app</a
						>
						as an example.
					</p>

					<p>
						After translating the store with the Translate & Adapt app, the
						values of the <b>Swatch trigger</b> and <b>Custom colors</b> fields
						in Theme settings > Color swatch will also be translated.
					</p>
					<p>
						For color swatches to work correctly, make sure that the translation
						of the option in <b>Swatch trigger</b> in the
						<i>Translate & Adapt > Theme > Theme settings > Color swatch</i>
						matches the option name in the product. Additionally, if you fill in
						the <b>Custom colors</b> field, make sure that the translations of
						the color names match the translations of the colors within the
						option.
					</p>
					<p>
						Important: On the product page and in filters, color swatches will
						work automatically and are not dependent on the
						<b>Swatch trigger</b> field if the product option is linked to a
						Category metafield.
					</p>

					<figure>
						<img
							src="/assets/imgs/docs/megastore/color_swatches_translate_1.webp"
						/>
					</figure>
					<figure>
						<img
							src="/assets/imgs/docs/megastore/color_swatches_translate_2.webp"
						/>
					</figure>

					<h3 id="product-card">Product Card</h3>
					<p>
						In the Theme settings > Product card section, you can customize the
						appearance of product cards across the entire theme.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/product_card_1.webp" />
					</figure>
					<ol>
						<li>
							The <b>Image ratio</b> setting applies a consistent image aspect
							ratio for product images in all cards.
						</li>
						<li>
							The <b>Hover effect</b> setting lets you choose the animation type
							when hovering over a product card. If you select
							<b>Show second image</b> but the product has only one image, the
							<b>Image zoom</b> effect will be applied automatically.
						</li>
						<li>
							The <b>Swatch type</b> setting allows you to choose how color
							swatches are displayed on product cards. If
							<b>Variant image</b> is selected, the swatch will show the variant
							image; if no image is available, it will automatically fall back
							to the <b>Color</b> type.
						</li>
					</ol>

					<h3 id="custom-badges">Custom Product Badges</h3>
					<p>
						To enable and edit Custom badges, navigate to Theme settings >
						Product card.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/custom_badges_4.webp" />
					</figure>
					<p>The next step is to add metafields to the products.</p>
					<p>To add and edit metafields, follow these steps:</p>
					<ol>
						<li>
							Navigate to Settings > Custom data in the Admin panel > Select
							Products > Click the button "Add definition".
							<figure>
								<img src="/assets/imgs/docs/megastore/custom_badges_1.webp" />
							</figure>
						</li>
						<li>
							Fill the fields. In the Name field enter "Badges" so that
							"custom.badges" appears in the Namespace and Key field. In the
							Select type field select "Single line text" and "List of values."
							<figure>
								<img src="/assets/imgs/docs/megastore/custom_badges_2.webp" />
							</figure>
						</li>
						<li>
							Navigate to the product and add information below.
							<figure>
								<img src="/assets/imgs/docs/megastore/custom_badges_3.webp" />
							</figure>
						</li>
					</ol>

					<h3 id="pagination">Pagination</h3>
					<p>
						For collection list pages, product list pages, the blog page and the
						search page, you can configure the pagination type. To select
						pagination type, navigate to Theme settings > Pagination >
						Pagination type.
					</p>
					<ol>
						<li>
							Classic pagination type
							<figure>
								<img src="/assets/imgs/docs/megastore/pagination_1.webp" />
							</figure>
						</li>
						<li>
							Load more type
							<figure>
								<img src="/assets/imgs/docs/megastore/pagination_2.webp" />
							</figure>
						</li>
						<li>
							Infinite scroll type
							<figure>
								<img src="/assets/imgs/docs/megastore/pagination_3.webp" />
							</figure>
						</li>
					</ol>

					<h3 id="back-to-top">Back to Top</h3>
					<p>
						To enable Back to Top button, navigate to Theme settings > Advanced.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/back_to_top.webp" />
					</figure>

					<!------------------------------ THEME SETTINGS (END) ------------------------------>

					<!------------------------------ HEADER GROUP (START) ------------------------------>

					<h2 id="header-group">Header Group</h2>

					<p>Sections that are used on all pages by default.</p>

					<h3 id="announcement-bar">Announcement Bar</h3>
					<p>
						The announcement bar appears at the top of every page and includes
						countdown timer, custom messages with optional links. It's good to
						use for promoting sales or need-to-know updates.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/ann_bar_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> selector allows you to change the color
							scheme. You can change the colors in the <b>Theme settings</b>.
						</li>
						<li>
							<b>Minimum height</b> slider allows you to change the announcement
							height only on desktop devices.
						</li>
						<li>
							<b>Minimum height on mobile devices</b> slider allows you to
							change the announcement height only on mobile devices.
						</li>
						<li>
							<b>Main text</b> field allows you to add and edit text for display
							on desktop devices.
						</li>
						<li>
							<b>Main text om mobile</b> field allows you to add and edit text
							for display on mobile devices.
						</li>
						<li>
							<b>Countdown timer options</b> allow you to place and manage a
							countdown timer.
						</li>
					</ol>

					<h3 id="header">Header</h3>
					<p>You can customize the header.</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/header_1.webp" />
					</figure>
					<ol>
						<li>
							The <b>Desktop header layout</b> setting allows you to choose
							different element layouts within the header on desktop devices..
						</li>
						<li>
							Use the <b>Sticky header</b> field to select a variant of the
							header when user scrolls in page.
						</li>
						<li><b>Enable search</b> allows you to add search interface.</li>
						<li>
							<b>Logo</b> options allow you to select and customize the
							appearance of the logo that will be displayed in the Header.
						</li>
						<li>
							<b>Menu</b> options allow you to select the primary and secondary
							menus, set a highlighted link in the primary menu, and provide
							additional contact information.
						</li>
						<li>
							<b>Main buttons</b> options allow you to manage the display of the
							cart, account, region/language switcher, and color scheme switcher
							buttons.
						</li>
						<li>
							<b>Shop mega menu button </b> options allow you to configure the
							display of the Shop All button, which is linked to the
							<a href="#shop-mega-menu" aria-label="Shop mega menu"
								>Shop Mega Menu section</a
							>. This button is intended for use in the store’s global catalog
							menu. If it’s not linked to the Shop Mega Menu section, it will
							direct users to the page specified in the Button link field.
						</li>
					</ol>

					<h4 id="header-mega-menu">Mega Menu Blocks</h4>

					<h4 id="header-mega-menu-cards">Mega Menu with Cards</h4>
					<p>
						Mega menu allows you to display up to 10 cards with an image and a
						link.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/mega_menu_cards_1.webp" />
					</figure>
					<ol>
						<li>Add the Mega menu with cards block to the Header.</li>
						<li>
							Type the exact name of the link in the <b>Trigger</b> field.
						</li>
						<li>
							Fill in the cards, for each card you can customize <b>Heading</b>,
							<b>Link</b> and <b>Image</b>.
						</li>
						<li>
							<b>Layout settings</b> located below the Card 10 settings allow
							you to customize the appearance of this type of mega menu.
						</li>
					</ol>

					<h4 id="header-mega-menu-tabs">Mega Menu with Tabs</h4>
					<p>
						Mega menu allows you to display up to 8 tabs, each with its own icon
						and submenu.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/mega_menu_tabs_1.webp" />
					</figure>
					<ol>
						<li>Add the Mega menu with cards block to the Header.</li>
						<li>
							Type the exact name of the link in the <b>Trigger</b> field.
						</li>
						<li>
							Fill in the tabs, for each tab you can customize <b>Title</b>,
							<b>Link</b>, <b>Icon</b> and inner <b>Menu</b>.
						</li>
					</ol>

					<h4 id="header-mega-menu-multilanguage">
						Multilanguage Mega Menu Trigger
					</h4>
					<p>
						In this section, we will show how to create multilingual mega menu
						trigger using the
						<a
							href="https://apps.shopify.com/translate-and-adapt"
							aria-label="Shopify Translate & Adapt app"
							target="_blank"
							>Shopify Translate & Adapt app</a
						>
						as an example.
					</p>

					<p>
						After translating the store with the Translate & Adapt app, the
						value of the <b>Trigger</b> field in Theme > Header group > Header >
						Mega menu block will also be translated.
					</p>
					<p>
						For the mega menu to work correctly in all languages, you need to
						ensure that the value in the <b>Mega Menu Trigger</b> field under
						<i>Translate & Adapt > Theme > Section groups > Header group</i>
						matches the Source value in the default language for each translated
						language.
					</p>

					<h4 id="header-search">Search Modal</h4>
					<p>
						In the Search modal, you can add an <b>additional menu</b> for quick
						customer access to your selected pages, a list of
						<b>popular products</b>, as well as <b>promo banner</b> that allow
						you to configure a promotional banner where you can set an image or
						video and display a message about a collection or promotion. The
						Search modal will appear beneath the search interface when the
						search input is focused.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/header_search_1.webp" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/megastore/search_modal_1.webp" />
					</figure>
					<p>
						In this theme, you can use a <b>predictive search</b>. It is enabled
						by default for header, but you can disable it in the Theme settings
						> Predictive search.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/predictive_search_1.webp" />
					</figure>

					<h4 id="shop-mega-menu">Shop Mega Menu Section</h4>
					<p>
						The Shop Mega Menu section allows you to add a tab block where you
						can set a custom icon and select a submenu. This section also lets
						you display a promo banner and a promo code banner.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/shop_mega_menu_1.webp" />
					</figure>
					<ol>
						<li>Add the Shop mega menu section to the Header group.</li>
						<li>
							Fill in the tabs blocks, for each tab block you can customize
							<b>Title</b>, <b>Link</b>, <b>Icon</b> and inner <b>Menu</b>.
						</li>
						<li>
							<b>Promo code</b> options allow you to add and configure a banner
							displaying a promo code with the ability to copy it.
						</li>
						<li>
							<b>Promo banner</b> options allow you to configure a promotional
							banner where you can set an image or video and display a message
							about a collection or promotion.
						</li>
					</ol>

					<!------------------------------ HEADER GROUP (END) ------------------------------>

					<!------------------------------ OVERLAY GROUP (START) ------------------------------>

					<h2 id="overlay-group">Overlay Group</h2>

					<h3 id="popup">Popup</h3>
					<p>
						In the Popup settings, you can change layout, add image, subscribe
						form, customize position, open and exit animations and other
						options.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/popup_1.webp" />
					</figure>
					<p id="popup-button-trigger">
						You can also use this popup as a button-trigger for opening another
						popup or notification bar by following these steps:
					</p>
					<ol>
						<li>
							Add the id of the popup/notification bar you chose to open to the
							<b>Id</b> field in the Triggers section (e.g. "popup").
						</li>
						<li>
							Navigate to the popup/notification bar settigns and add the Id
							with "#" in the beginning to the
							<b>"CSS selector for manual trigger"</b> field.
						</li>
					</ol>
					<figure>
						<img src="/assets/imgs/docs/megastore/popup_2.webp" />
					</figure>
					<figure>
						<img src="/assets/imgs/docs/megastore/popup_3.webp" />
					</figure>

					<h3 id="notification-banner">Notification Banner</h3>
					<p>
						In the Notification Banner settings, you can change layout, add
						image, texts, customize banner position, change open and exit
						animations and other options.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/notification_banner_1.webp" />
					</figure>
					<p>
						You can also use this banner as a
						<a href="#popup-button-trigger">button-trigger</a> for opening
						another notification bar or a popup.
					</p>

					<h3 id="notification-bar">Notification Bar</h3>
					<p>
						This section allows you to display a bar with a message or
						notification at the top or bottom of the page, spanning its full
						width.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/notification_bar_1.webp" />
					</figure>
					<p>
						You can also use this banner as a
						<a href="#popup-button-trigger">button-trigger</a> for opening
						another notification bar or a popup.
					</p>

					<h3 id="age-verifier">Age Verification Popup</h3>
					<p>
						An Age verification popup is a prompt that appears on a website to
						confirm the user's age before accessing restricted content. In the
						Age verification popup settings, you can change customize text and
						buttons.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/age_verification_1.webp" />
					</figure>

					<!------------------------------ OVERLAY GROUP (END) ------------------------------>

					<!------------------------------ FOOTER GROUP (START) ------------------------------>

					<h2 id="footer-group">Footer Group</h2>

					<p>Sections is used on all pages by default.</p>

					<h3 id="footer">Footer</h3>
					<p>
						Footer appears at the bottom of every page. You can customize it to
						fit your brand and product offerings.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/footer_1.webp" />
					</figure>
					<ol>
						<li>
							Use <b>Color scheme</b> selector to change the color scheme.
						</li>
						<li>
							<b>Enable border top</b> field enables a line above the section.
						</li>
						<li>
							<b>Country/region selector</b> field enables the display of the
							region selector in the footer.
						</li>
						<li>
							<b>Language selector</b> field enables the display of the language
							selector in the footer.
						</li>
						<li>
							<b>Payment methods</b> field enables the display of payment
							methods in the bottom line of the footer.
						</li>
						<li><b>Copyright</b> allow to show info about copyright.</li>
						<li>
							<b>Policy Links</b> field enables the display of the policies
							links in the footer.
						</li>
						<li>
							<b>Follow On Shop</b> allow customers to follow your store on the
							Shop app from your storefront, Shop Pay must be enabled.
						</li>
						<li>
							<b>Logo info block</b>
							<ul>
								<li>
									Use the <b>Logo image</b> file selector allows you to select
									or upload your logo file.
								</li>
								<li>
									Use the <b>Dark mode logo image</b> file selector to select or
									upload your logo, which can be seen in Dark mode.
								</li>
								<li>
									If you add a logo, you can use the
									<b>Custom logo width </b>slider to change the logo size.
								</li>
								<li>
									<b>Description</b> allows you to add additional description
									under the logo.
								</li>
							</ul>
						</li>
						<li>
							Block <b>Subscribe form and social media</b> allows you to add and
							customize subscribe form and display social media icons.
						</li>
						<li>
							Block <b>Menu</b> allows you to select menus, which will be
							displayed on the top line of the footer.
						</li>
					</ol>

					<!------------------------------ FOOTER GROUP (END) ------------------------------>

					<!------------------------------ SECTIONS (START) ------------------------------>

					<h2 id="all-sections">Sections</h2>
					<p>
						The theme contains several customizable sections that you can add to
						your page in any order.
					</p>

					<h3 id="sections-general-settings">General Settings</h3>
					<p>Settings that are used in almost all sections.</p>

					<h3 id="section-margin">Section Margin</h3>
					<p>Allows you to change the top and bottom margin in the section</p>
					<ol>
						<li>
							<b>Top margin</b> slider allows you to change the top margin in
							the section.
						</li>
						<li>
							<b>Bottom margin</b> slider allows you to change the bottom margin
							in the section.
						</li>
					</ol>
					<figure>
						<img src="/assets/imgs/docs/megastore/margin_1.webp" />
					</figure>

					<h3 id="section-padding">Section Padding</h3>
					<p>Allows you to change the top and bottom padding in the section</p>
					<ol>
						<li>
							<b>Top padding</b> slider allows you to change the top padding in
							the section.
						</li>
						<li>
							<b>Bottom padding</b> slider allows you to change the bottom
							padding in the section.
						</li>
					</ol>
					<figure>
						<img src="/assets/imgs/docs/megastore/padding_1.webp" />
					</figure>

					<h3 id="featured-collection">Featured Collection</h3>
					<p>
						The section allows you to display products from a selected
						collection. Additionally, you can display up to 2 promo cards or a
						collection card.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/featured_collection_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> allows you to change the color scheme of the
							section.
						</li>
						<li>
							<b>Collection</b> allows you to select the featured collection.
						</li>
						<li>
							<b>Overwrite products</b> allows you to select a custom list of
							products that will be displayed instead of the collection's
							products.
						</li>
						<li>
							<b>Content options</b> allows you to set a heading, subheading,
							description for the section and customize it.
						</li>
						<li>
							<b>Collection card</b> block allows you to display a collection
							card with customizable content and image. It will not appear if at
							least one Promo card block is enabled.
						</li>
						<li>
							<b>Promo card</b> block allows you to display and customize the
							content of a promotion or offer, and set up an image or video for
							display.
						</li>
					</ol>

					<h3 id="featured-product">Featured Product</h3>
					<p>
						In this section, you can display a single product and provide
						information about it. This section is similar to
						<a href="#product-information">Product information</a>, but with
						limited functionality.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/featured_product_1.webp" />
					</figure>

					<h3 id="rte">Rich text</h3>
					<p>This section allows you to add Rich text content block.</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/rich_text_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> selector changes the color scheme for the
							section.
						</li>
						<li>
							<b>Full width</b> toggle changes the width of the section (full
							screen or inside container).
						</li>
						<li><b>Position</b> allows you to change content position.</li>
						<li>
							This section contains 5 block types. You can add up to 5 blocks
							(one of each type), including:<br />
							<ol>
								<li><b>Subheading</b> allows you to add a subheading.</li>
								<li>
									<b>Heading</b> allows you to add a heading and customize its
									size.
								</li>
								<li>
									<b>Text</b> allows you to add a description (rich text
									content).
								</li>
								<li>
									<b>Button</b> allows you to add a button and customize it.
								</li>
								<li>
									<b>Author</b> allows you to add a author's name, position and
									image.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="image-with-text">Image with Text</h3>
					<p>This section allows you to add image with text (content) block.</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/image_with_text_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Main options</b> allows you to set a color scheme, subheading,
							heading and description for the section.
						</li>
						<li>
							<b>Image Options</b> allows you to set a image for the section and
							customize it.
						</li>
						<li>
							<b>Primary button options</b> and
							<b>Secondary button options</b> allows you to add primary and
							secondary buttons and customize them.
						</li>
					</ol>

					<h3 id="slideshow">Slideshow</h3>
					<p>
						The section allows you to add slides with image, heading,
						description and promo code.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/slideshow_1.webp" />
					</figure>
					<ol>
						<li><b>Aspect ratio</b> sets the aspect ratio of the image.</li>
						<li>
							<b>Slider options</b> allow you to customize slider, switch loop
							mode, pagination, navigation, autoplay.
						</li>
						<li>
							Block <b>Slide</b> option<b> Color scheme</b> allows you to set
							the color scheme for the slide.
						</li>
						<li>
							Block <b>Slide</b> option<b> Image</b> allows you to set a image
							for the slide.
						</li>
						<li>
							Block <b>Slide</b> option<b> Overlay opacity</b> allows you to
							change the opacity of the overlay.
						</li>
						<li>
							Block <b>Slide</b> option<b> Video</b> allows you to set a video
							for the slide.
						</li>
						<li>
							Block <b>Slide</b> option<b> Heading</b> allows you to set a
							heading for the slide.
						</li>
						<li>
							Block <b>Slide</b> option<b> Description</b> allows you to set a
							description for the slide.
						</li>
						<li>
							Block <b>Slide</b> <b>Button options</b> allows you to set a
							button and customize it.
						</li>
					</ol>

					<h3 id="multicolumn">Multicolumn</h3>
					<p>This section allows you to add multiple columns of content.</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/multicolumn_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Main options</b> allows you to set a color scheme, heading and
							description for the section. Also you can .
						</li>
						<li>
							<b>Columns per row</b> allows you to select the number of columns
							in one row.
						</li>
						<li>
							<b>Enable swipe for mobile</b> allows you to display this section
							as slider on mobile.
						</li>
						<li>
							<b>Column options</b> allows you to customize each column.
							Includes following options: Heading size, Color scheme, Padding.
						</li>
						<li>
							Each <b>Column block</b> includes settings that allow you to
							configure the column's content and image.
						</li>
					</ol>

					<h3 id="collapsible-content">Collapsible Content</h3>
					<p>
						You can add and customize a collapsible content section, such as
						using it for FAQs.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/collapsible_content_1.webp" />
					</figure>
					<ol>
						<li>
							For each collapsible row block, you can set a
							<b>Heading</b> (question) that will always be displayed and a
							collapsible <b>Description</b> (answer).
						</li>
						<li>You can also choose special rows to be opened by default.</li>
					</ol>

					<h3 id="banner-grid">Banner Grid</h3>
					<p>
						This section allows you to add a grid of cards with background image
						or video and texts.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/banner_grid_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> selector changes the color scheme for the
							section.
						</li>
						<li>
							<b>Layout</b> field allows you to set the layout of grid columns.
						</li>
						<li>
							<b>Columns</b> field allows you to set the number of grid columns.
						</li>
						<li>
							<b>Card media ratio</b> allows you to set the aspect ratio of the
							all cards.
						</li>
						<li>
							This section contains one block type - <b>Card</b>.<br />
							<b>Card</b> options includes:
							<ol>
								<li>
									<b>Color scheme</b> selector changes the color scheme for the
									card.
								</li>
								<li>
									<b>Image and video options</b> allows you to set background
									image or video for the card. Includes:
									<ol>
										<li>
											<b>Background image</b> allows you to set background image
											for the card.
										</li>
										<li>
											<b>Video</b> allows you to set a video for the card.
										</li>
										<li>
											<b>Overlay opacity</b> slider allows you to change the
											opacity of the overlay.
										</li>
										<li>
											<b>Card aspect ratio on mobile devices</b> allows you to
											set the aspect ratio of the card on mobile devices.
										</li>
									</ol>
								</li>
								<li>
									<b>Content options</b> allows you to add a subheading,
									heading, description and button for the card.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="banner-slider">Banner Slider</h3>
					<p>
						The section allows you to add slides with image, heading and
						description.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/banner_slider_1.webp" />
					</figure>
					<ol>
						<li><b>Aspect ratio</b> sets the aspect ratio of the slides.</li>
						<li>
							<b>Slider options</b> allow you to customize slider, switch loop
							mode, pagination, navigation, autoplay.
						</li>
						<li>
							Block <b>Banner</b> option<b> Color scheme</b> allows you to set
							the color scheme for the slide.
						</li>
						<li>
							Block <b>Banner</b> option<b> Image</b> allows you to set a image
							for the slide.
						</li>
						<li>
							Block <b>Banner</b> option<b> Overlay opacity</b> allows you to
							change the opacity of the overlay.
						</li>
						<li>
							Block <b>Banner</b> option<b> Video</b> allows you to set a video
							for the slide.
						</li>
						<li>
							Block <b>Banner</b> option<b> Heading</b> allows you to set a
							heading for the slide.
						</li>
						<li>
							Block <b>Banner</b> option<b> Description</b> allows you to set a
							description for the slide.
						</li>
					</ol>

					<h3 id="before-after">Before / After</h3>
					<p>Showcase compelling visual comparisons with this section.</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/before_after_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Image options</b> allow you to set "before" and "after" images,
							a label for each image, as well as the aspect ratio on desktop and
							mobile devices for the image container.
						</li>
						<li>
							<b>Content options</b> let you set and configure the display of
							the subheading, heading, and description.
						</li>
						<li>
							<b>Products options</b> allow you to select and display a list of
							products in the section. This section can be used to highlight the
							benefits of these products.
						</li>
					</ol>

					<h3 id="blog-posts">Blog Posts</h3>
					<p>
						The section allows you to select a blog and display its blog posts.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/blog_posts_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Blog</b> field allows you to choose a blog which posts will be
							displayed.
						</li>
						<li>
							<b>Color scheme</b> selector allows you to change the color scheme
							of the section.
						</li>
						<li>
							<b>Header options</b> allows you to set a subheading and heading
							for the section. Header options includes the following:<br />
							<ol>
								<li>
									<b>Section header text</b> allows you to set a text for the
									section header.
								</li>
								<li>
									<b>Section header size</b> allows you to change the size of
									the section header text.
								</li>
							</ol>
						</li>
						<li>
							<b>Posts layout options</b> allows you to customize posts layout.
							Includes following options:<br />
							<ol>
								<li>
									<b>Enable slider</b> allows you to display this section as
									slider.
								</li>
								<li>
									<b>Posts per row</b> slider allows you to select the number of
									posts in one row.
								</li>
								<li>
									<b>Posts count</b> slider allows you to change the number of
									displayed posts.
								</li>
							</ol>
						</li>
						<li>
							<b>Post Image Options</b> allows you to customize post's image.
							<b>Post Image Options</b> includes:<br />
							<ol>
								<li>
									<b>Show post image</b> allows you to show or hide post's
									image.
								</li>
								<li>
									<b>Image ratio</b> allows you to choose the orientation of
									pictures for cards.
								</li>
								<li>
									<b>Image fit</b> allows you to choose the fit of pictures for
									cards.
								</li>
							</ol>
						</li>
						<li>
							<b>Post content options</b> allows you to customize post's image
							and title. <b>Post content options</b> includes:<br />
							<ol>
								<li>
									<b>Show post date</b> allows you to show or hide post's date
									of publication in post card.
								</li>
								<li>
									<b>Show post tags</b> allows you to show or hide post's tags
									in post card.
								</li>
								<li>
									<b>Show post author</b> allows you to show or hide post's
									author in post card.
								</li>
								<li>
									<b>Show post excerpt</b> allows you to show or hide post's
									excerpt in post card.
								</li>
								<li>
									<b>Show comments count</b> allows you to show or hide comments
									count in post card.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="brands">Brands</h3>
					<p>
						Showcase your partners or affiliations with this section. This
						section is perfect for building credibility and showcasing key
						partnerships effectively.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/brands_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Show full vendor list</b> settings allows you to display a list
							of all product vendors in your store, sorted in alphabetical
							order.
						</li>
						<li>
							The <b>Logo block</b> lets you showcase your own brands or your
							partners’ brands. Each Logo block includes image settings and an
							option to set a link.
						</li>
					</ol>

					<h3 id="collections-list">Collections List</h3>
					<p>Displays a list of featured collections.</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/collections_list_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> allows you to change the color scheme of the
							section.
						</li>
						<li>
							<b>Main options</b> allows you to set a heading, description for
							the section and customize it.
						</li>
						<li>
							<b>Mobile layout</b> allows you to select the layout of the slider
							on mobile devices.
						</li>
						<li>
							<b>Image ratio</b> allows you to set the aspect ratio of the
							image.
						</li>
						<li>
							<b>Image fit</b> allows you to set the object fit for the image.
						</li>
						<li>
							<b>Collection</b> block allows you to select collection and
							customize it. Includes following options:<br />
							<ol>
								<li><b>Collection</b> allows you to select collection.</li>
								<li>
									<b>Image</b> field allows you to overwrite collection's
									featured image.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="countdown">Countdown</h3>
					<p>
						You can add and customize a countdown timer. If you add an image,
						this section will be displayed as two blocks; otherwise, it will be
						displayed as a single block.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/countdown_1.webp" />
					</figure>
					<ol>
						<li>
							Use the <b>Color scheme</b> selector to change the color scheme of
							the section and the <b>Content color scheme</b> selector to adjust
							the inner content's color scheme.
						</li>
						<li>
							The <b>End year</b>, <b>End month</b>, <b>End day</b>,
							<b>End hour</b> and <b>End minutes</b> options allow you to set
							the countdown's end date and end time.
						</li>
						<li>
							<b>After the timer ends</b> allows you to specify what should
							happen when the countdown is completed: either the section will be
							hidden, or a special text will be displayed.
						</li>
						<li>
							<b>Text after the timer ends</b> will be shown if the
							<i>Show text</i> option is selected.
						</li>
						<li>
							The <b>Image</b> option allows you to set an image for the
							section.
						</li>
						<li>
							The <b>Overlay opacity</b> allows you to adjust the overlay's
							opacity to the image.
						</li>
						<li>
							Use the <b>Running line</b> block to display scrolling text.
						</li>
						<li>
							The <b>Promo banner</b> block allows you to showcase a promotional
							offer.
						</li>
					</ol>

					<h3 id="product-carousel">Popular Products</h3>
					<p>
						The section allows you to display popular products and customize
						their display.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/popular_products_1.webp" />
					</figure>
					<ol>
						<li>
							You can set the number of blocks per row using the
							<b>Products per row</b> option.
						</li>
						<li>
							Additionally, you can customize the product cards options in this
							section.
						</li>
						<li>
							The <b>Button options</b> allow you to set a button and customize
							it.
						</li>
					</ol>

					<h3 id="product-markers">Product Markers</h3>
					<p>
						The section allows you to mark products in the image and choose
						display position.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/product_markers_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Product marker block</b> allows you to select a product, image
							and set the position of its marker.
						</li>
						<li><b>Image ratio</b> sets the aspect ratio of the image.</li>
					</ol>

					<h3 id="product-tabs">Products Tabs</h3>
					<p>
						This section allows you to display a set of products and organize
						them into tabs using special filters.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/product_tabs_1.webp" />
					</figure>
					<ol>
						<li>
							Within each <b>Tab</b> block, you can specify the tab's name and
							choose the products to display in that tab.
						</li>
					</ol>

					<h3 id="testimonials">Testimonials</h3>
					<p>
						This section allows you to add and customize testimonials (clients
						reviews).
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/testimonials_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Main options</b> allows you to set a color scheme, heading and
							description for the section and customize it.
						</li>
						<li>
							<b>Testimonials slide</b> block allows you to add and customize
							testimonials (clients reviews). Each block has the following
							options:<br />
							<ol>
								<li>
									<b>Product</b> allows you to set a product that is related to
									the review.
								</li>
								<li><b>Show image</b> allows you to display product image.</li>
								<li><b>Text</b> allows you to set a text of the review.</li>
								<li>
									<b>Author's name</b> allows you to set the name of the author
									of the review.
								</li>
								<li><b>Review score</b> allows you to set a review score.</li>
							</ol>
						</li>
					</ol>

					<h3 id="ticker">Ticker</h3>
					<p>
						This section allows you to set up a running line with a message and
						an image.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/ticker_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Color scheme</b> selector changes the color scheme for the
							section.
						</li>
						<li><b>Text</b> allows you to set a running text.</li>
						<li>
							You can configure the <b>speed</b> and <b>direction</b> of the
							running line.
						</li>
						<li>
							Using the <b>Link</b> setting, you can make the entire section
							clickable, redirecting users to the specified link.
						</li>
					</ol>

					<!------------------------------ SECTIONS (END) ------------------------------>

					<!------------------------------ PAGES (START) ------------------------------>

					<h2 id="page">Pages</h2>

					<p>Information on theme pages.</p>

					<h3 id="product-page">Product Page</h3>

					<h4 id="product-information">Product Information</h4>
					<p>
						The Product information section allows users to view all relevant
						information about the product.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/product_information_1.webp" />
					</figure>
					<ol>
						<li>This section features a customizable <b>Color Scheme</b>.</li>
						<li>
							Using the <b>Desktop layout type</b> and
							<b>Mobile layout type</b> settings, you can configure different
							types of media galleries for different devices.
						</li>
						<li>
							With the <b>Aspect ratio</b> and
							<b>Thumbnails aspect ratio</b> settings, you can set aspect ratios
							for the main images in the gallery. Thumbnails are displayed if
							the layout type Slider with previews is selected.
						</li>
						<li>
							Specify the image fit for the main gallery slider and thumbnails
							using the <b>Image fit</b> and
							<b>Thumbnails image fit</b> settings.
						</li>
						<li>
							In this section, you can add rating, pickup and delivery
							information, promo banner, help banner, recently viewed products,
							complementary products and product recommendations.
						</li>
					</ol>

					<h4 id="product-recommendations">Product Recommendations</h4>
					<p>
						Dynamic recommendations use order and product information to change
						and improve over time.
					</p>
					<p>
						To add and edit product recommendations, install the
						<b>Search & Discovery app</b> by Shopify from the Apps page in the
						Admin panel. Once installed, open the app and follow the
						"Recommendations" link in the Feature overview section to add
						recommendations to your products.
					</p>
					<figure>
						<img
							src="/assets/imgs/docs/megastore/product_recommendations_1.webp"
						/>
					</figure>

					<p>Settings for this section look like below:</p>
					<figure>
						<img
							src="/assets/imgs/docs/megastore/product_recommendations_2.webp"
						/>
					</figure>
					<ol>
						<li><b>Heading</b> allows you to set a heading for the section.</li>
						<li>
							<b>Heading size</b> selector field allows you to change the size
							of the section header.
						</li>
						<li>
							<b>Product card</b> options allow you to customize product cards
							in the section.
						</li>
					</ol>

					<h4 id="variant-picker">Variant Picker</h4>
					<p>
						You can choose between two types for the Variant Picker: Pills and
						Dropdown.
					</p>

					<h4 id="variant-picker-pills">Pills</h4>
					<p>
						Pills display options as buttons. In this type, the color option can
						be shown as <a href="#color-swatches">Color swatches</a>.
					</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/picker_pills_1.webp" />
					</figure>

					<h4 id="variant-picker-dropdown">Dropdown</h4>
					<p>Dropdown allows variant selection through dropdown options.</p>
					<figure>
						<img src="/assets/imgs/docs/megastore/picker_dropdown_1.webp" />
					</figure>

					<h3 id="collections-page">Collections Page</h3>
					<figure>
						<img src="/assets/imgs/docs/megastore/collection_page_1.webp" />
					</figure>

					<h4 id="collection-banner">Collection Banner</h4>
					>
					<ol>
						<li><b>Show collection image</b> field turn on image display.</li>
						<li>
							<b>Image for "Products" page</b> image for automatically generated
							page with all products.
						</li>
					</ol>

					<h4 id="product-grid">Product Grid</h4>
					<ol>
						<li>
							<b>Products per page</b> field sets the number of displayed cards.
						</li>
						<li>
							<b>Product card</b> options allow you to customize product cards
							in the section.
						</li>
						<li><b>Enable filtering</b> field turn filtering.</li>
						<li><b>Enable sorting</b> field turn sorting.</li>
					</ol>

					<h3 id="collections-list-page">Collections List</h3>
					<p>Displays a list of all collections.</p>
					<figure>
						<img
							src="/assets/imgs/docs/megastore/collection_list_page_1.webp"
						/>
					</figure>
					<ol>
						<li><b>Heading</b> field sets a header section.</li>
						<li>
							<b>Collections per row</b> slider allows you to change the number
							of collections per line only on desktop devices.
						</li>
						<li>
							<b>Sort collections by</b> field filters the collection by the
							specified parameters
						</li>
						<li>
							<b>Image ratio</b> field allows you to choose the orientation of
							images for cards.
						</li>
						<li>
							<b>Image fit</b> field allows you to choose the fit of pictures
							for cards.
						</li>
						<li>
							<b>Show description</b> enables the display of the collection
							description.
						</li>
					</ol>

					<h3 id="cart">Cart</h3>
					<figure>
						<img src="/assets/imgs/docs/megastore/cart_page_1.webp" />
					</figure>

					<h4 id="cart-shipping">Free shipping message</h4>
					<p>
						To add and edit cart free shipping progress bar, follow these steps:
					</p>
					<ol>
						<li>
							Enable the Theme settings > Cart > Free shipping message > Show
							free shipping message.
						</li>

						<li>
							Set the value required to qualify for free shipping. This value
							should be specified in the store's default currency. For customers
							using other currencies, conversion will be applied.
						</li>

						<li>
							Create a
							<a
								href="https://help.shopify.com/en/manual/discounts/discount-types/free-shipping"
								target="_blank"
								>free shipping discount</a
							>
							in the store and set the same amount, or configure a
							<a
								href="https://help.shopify.com/en/manual/fulfillment/setup/shipping-rates/flat-shipping-rates#create-free-shipping-rates"
								target="_blank"
								>shipping rate</a
							>.
						</li>

						<li>
							To create and edit a shipping rate, go to the store settings under
							the Shipping and delivery tab.
						</li>
					</ol>

					<h3 id="blog">Blog</h3>
					<figure>
						<img src="/assets/imgs/docs/megastore/blog_page_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Posts per page</b> slider allows you to change the number of
							posts per page.
						</li>
						<li>
							<b>Posts per row</b> slider allows you to select the number of
							posts in one row.
						</li>
						<li>
							<b>Featured posts</b> options allows you to customize featured
							post(s). To add a featured post(s), add at least one
							<b>Featured post</b> block. <b>Featured posts</b> options
							includes:<br />
							<ol>
								<li>
									<b>Image ratio</b> allows you to set the aspect ratio of the
									Featured posts slider on desktop devices.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in featured post.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									featured post.
								</li>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									featured post.
								</li>
								<li>
									<b>Show excerpt</b> allows you to show or hide post's excerpt
									in featured post.
								</li>
							</ol>
						</li>
						<li>
							<b>Post content options</b> allows you to customize post's image
							and content.<br />
							Post content options includes:<br />
							<ol>
								<li>
									<b>Show image</b> allows you to show or hide post's image.
								</li>
								<li>
									<b>Image ratio</b> allows you to choose the orientation of
									pictures for cards.
								</li>
								<li>
									<b>Image fit</b> allows you to choose the fit of pictures for
									cards.
								</li>
								<li>
									<b>Title font size</b> allows you to select the size of the
									post's title.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in post card.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									post card.
								</li>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									post card.
								</li>
								<li>
									<b>Show excerpt</b> allows you to show or hide post's excerpt
									in post card.
								</li>
								<li>
									<b>Show comments count</b> allows you to show or hide comments
									count in post card.
								</li>
							</ol>
						</li>
						<li>
							<b>Featured post</b> block has following options:<br />
							<ol>
								<li><b>Post</b> allows you to select a post.</li>
								<li>
									<b>Color scheme</b> allows you to select the color scheme for
									the block.
								</li>
								<li>
									<b>Overlay opacity</b> allows you to change the opacity of the
									image overlay.
								</li>
							</ol>
						</li>
					</ol>

					<h3 id="blog-post">Blog Post</h3>
					<figure>
						<img src="/assets/imgs/docs/megastore/blogpost_1.webp" />
					</figure>
					<ol>
						<li>
							<b>Comments section color scheme</b> allows you to select the
							color scheme for the comments section.
						</li>
						<li>
							<b>Comment color scheme</b> allows you to select the color scheme
							for comments.
						</li>
						<li>
							This section contains 4 block types:<br />
							<ol>
								<li><b>Article header</b></li>
								<li><b>Content</b></li>
								<li><b>Article footer</b></li>
								<li><b>Sidebar</b></li>
							</ol>
						</li>
						<li>
							<b>Article header</b> block has following options:
							<ol>
								<li>
									<b>Color scheme</b> allows you to select the color scheme for
									article header's text block.
								</li>
								<li>
									<b>Image ratio</b> selector allows you to choose the aspect
									ratio of the post's feature image.
								</li>
								<li>
									<b>Show excerpt</b> allows you to show or hide post's excerpt
									in article header.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in article's header.
								</li>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									article's header.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									article's header.
								</li>
							</ol>
						</li>
						<li>
							<b>Article footer</b> block has following options:
							<ol>
								<li>
									<b>Show author</b> allows you to show or hide post's author in
									article's footer.
								</li>
								<li>
									<b>Show tags</b> allows you to show or hide post's tags in
									article's footer.
								</li>
								<li>
									<b>Show date</b> allows you to show or hide post's date of
									publication in article's footer.
								</li>
								<li>
									<b>Share</b> options allows you to enable share block and each
									share link from the list.
								</li>
							</ol>
						</li>
						<li>
							<b>Sidebar</b> block allows you to display the next post and
							customize its card, select a list of products and show them in the
							sidebar, and add a promo banner.
						</li>
					</ol>

					<!------------------------------ PAGES (END) ------------------------------>

					<!------------------------------ DEMOS (START) ------------------------------>

					<h2 id="import-demos">Importing Our Demos</h2>

					<p>You can also copy the structure of our demo in a few steps.</p>
					<ol>
						<li>
							<a href="#demos-structure">Download the settings file</a> to copy
							the demo settings from there.
						</li>
						<li>
							<p>
								Go to section <b>"Online Store >> Themes"</b> your store.
								<b>Click on the three dots button</b> of your theme. Go to the
								code editor
								<b>by clicking the edit code button</b>
							</p>
							<figure>
								<img src="/assets/imgs/docs/megastore/import_demos_1.webp" />
							</figure>
						</li>
						<li>
							<p>
								In the code editor, search for the file <b>"index.json"</b> and
								change the code to the
								<a href="#demos-structure">demo code</a> you want to transfer.
								Click <b>"save"</b> to save your changes.
							</p>
							<figure>
								<img src="/assets/imgs/docs/megastore/import_demos_1.webp" />
							</figure>
						</li>
					</ol>
					<h2 id="demos-structure">Demos Structure</h2>
					<p>
						Click on the demo name to download the file with the appropriate
						structure.
					</p>
					<ol>
						<li id="modern">
							<a href="/assets/files/megastore/megastore.txt" download=""
								>Megastore</a
							>
						</li>
					</ol>

					<!------------------------------ DEMOS (END) ------------------------------>

					<!------------------------------ SUPPORT ------------------------------>

					<h2 id="support">Support</h2>

					<p>
						You can ask any questions about the theme and our support agent will
						help you within 24 hours on business days.
					</p>
					<router-link to="/help-center/" class="sh-link-arrow">
						<span class="sh-link-arrow__name">Visit Help Center</span>
						<span class="sh-link-arrow__icon">
							<svg
								viewBox="0 0 24 25"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M16.004 9.914L7.39697 18.521L5.98297 17.107L14.589 8.5H7.00397V6.5H18.004V17.5H16.004V9.914Z"
									fill="currentColor"
								></path>
							</svg>
						</span>
					</router-link>
					&nbsp;&nbsp;&nbsp;&nbsp;
					<router-link to="/privacy/" class="sh-link-arrow">
						<span class="sh-link-arrow__name">View Terms & Conditions</span>
						<span class="sh-link-arrow__icon">
							<svg
								viewBox="0 0 24 25"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M16.004 9.914L7.39697 18.521L5.98297 17.107L14.589 8.5H7.00397V6.5H18.004V17.5H16.004V9.914Z"
									fill="currentColor"
								></path>
							</svg>
						</span>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
@import "@/assets/scss/_documentation.scss";
</style>

<script setup>
import { onMounted } from "vue";

onMounted(() => {
	const sidebar = document.querySelector(
		".sh-documentation-theme__sidebar-nav"
	);

	if (!sidebar) return;

	sidebar.addEventListener("click", (e) => {
		const link = e.target.closest("a");
		if (!link || !link.hash) return;

		const targetId = link.hash.slice(1);
		const targetElement = document.getElementById(targetId);
		if (!targetElement) return;

		e.preventDefault();

		const targetPosition =
			targetElement.getBoundingClientRect().top + window.pageYOffset;
		window.scrollTo({
			top: targetPosition - 32,
			behavior: "smooth",
		});
	});
});
</script>
